import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Spinner } from 'app/components/spinner';
import { ParamUtils } from 'app/utils/param-utils';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { OrderStep } from 'app/pages/order/redux/model/order-step';
import { assertNotNil } from 'app/utils/type-utils';
import { NavigationService } from 'app/services/navigation-service';
import { useGoToStep } from 'app/hooks/use-go-to-step';

import { fetchAccessTokenActionCreator } from './redux/action-creators/fetch-access-token-action-creator';

const AuthCallbackPage: React.FunctionComponent = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const goToStep = useGoToStep();

    React.useEffect(() => {
        const code = ParamUtils.getQueryParam('code');
        const stateParam = ParamUtils.getQueryParam('state');

        assertNotNil(code, 'Code parameter must be present');
        assertNotNil(stateParam, 'State parameter must be present');

        dispatch(fetchAccessTokenActionCreator({ code, stateParam }))
            .unwrap()
            .then(() => goToStep(OrderStep.CHOOSE_ACCOUNT, true))
            .catch(() => navigate(NavigationService.ERROR));
    }, [navigate, goToStep, dispatch]);

    return <Spinner />;
};

export { AuthCallbackPage };
